var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C12.36239415 0.85779653 12.36239415 0.85779653 24.75 1 C24.42 1.66 24.09 2.32 23.75 3 C27.38 3.66 31.01 4.32 34.75 5 C35.08 4.34 35.41 3.68 35.75 3 C35.75 3.99 35.75 4.98 35.75 6 C36.86375 6.12375 37.9775 6.2475 39.125 6.375 C46.82519407 7.33580853 54.0756465 8.89326296 61.2734375 11.80859375 C66.61708739 13.95672161 71.99037134 16.01964746 77.375 18.0625 C78.70917969 18.57006836 78.70917969 18.57006836 80.0703125 19.08789062 C89.36364427 22.67363775 89.36364427 22.67363775 98.75 26 C100.0850765 26.99767155 101.41808243 27.9981151 102.75 29 C104.84174491 30.20924639 106.94766872 31.39409841 109.0625 32.5625 C120.17344143 38.81983018 130.67060413 45.89648386 140.62719727 53.86474609 C143.01953282 55.76425821 144.81938676 57.02312892 147.75 58 C148.5853125 59.051875 148.5853125 59.051875 149.4375 60.125 C152.47851292 63.90571876 156.01402011 66.92073533 159.75 70 C160.430625 70.56460938 161.11125 71.12921875 161.8125 71.7109375 C163.77842626 73.27696262 163.77842626 73.27696262 166.75 73 C166.42 73.66 166.09 74.32 165.75 75 C166.08 75.33 166.41 75.66 166.75 76 C176.14726062 86.03102936 184.70224971 96.72654969 192.41015625 108.109375 C193.74947773 110.1115247 193.74947773 110.1115247 195.75 112 C197.14221805 114.29758685 198.49125806 116.59991811 199.8125 118.9375 C200.17666016 119.57107422 200.54082031 120.20464844 200.91601562 120.85742188 C202.44613804 123.54715647 203.76886389 126.05659166 204.75 129 C205.41 129.33 206.07 129.66 206.75 130 C207.875 132.0625 207.875 132.0625 208.75 134 C210.3754308 133.85904936 212.00034051 133.71207913 213.625 133.5625 C214.52992188 133.48128906 215.43484375 133.40007812 216.3671875 133.31640625 C218.76110861 133.13010715 218.76110861 133.13010715 220.75 132 C222.70003732 132.20952529 224.64989041 132.42680436 226.59179688 132.70166016 C228.49701696 132.96502881 230.41263505 133.15065361 232.328125 133.32421875 C260.00467013 136.06243013 285.72460012 148.47707312 304.75 169 C304.75 169.66 304.75 170.32 304.75 171 C305.41 171 306.07 171 306.75 171 C308.62946652 173.31800871 310.38976326 175.64001818 312.125 178.0625 C312.60710938 178.71927734 313.08921875 179.37605469 313.5859375 180.05273438 C315.8976096 183.24070609 318.05299078 186.43308813 319.9765625 189.87109375 C321.55859023 192.98625355 321.55859023 192.98625355 323.75 195 C324.58789063 196.75244141 324.58789063 196.75244141 325.40625 198.8515625 C325.70660156 199.62113281 326.00695312 200.39070312 326.31640625 201.18359375 C326.77853516 202.39208984 326.77853516 202.39208984 327.25 203.625 C327.71212891 204.79869141 327.71212891 204.79869141 328.18359375 205.99609375 C330.59645728 212.24054315 332.75 218.23469794 332.75 225 C333.41 225.33 334.07 225.66 334.75 226 C339.4060758 251.95981887 334.9185898 280.5578848 322.51953125 303.64453125 C320.5582822 307.36354435 319.07676116 311.01971652 317.75 315 C317.09 315 316.43 315 315.75 315 C314.58891728 316.52068314 313.49826529 318.09521634 312.4375 319.6875 C295.81802078 343.05111571 269.90172852 358.77130022 241.74609375 363.54296875 C235.43035543 364.37287646 229.10414522 364.24649701 222.75 364 C222.75 364.66 222.75 365.32 222.75 366 C221.76 366.33 220.77 366.66 219.75 367 C219.75 366.34 219.75 365.68 219.75 365 C219.09 364.67 218.43 364.34 217.75 364 C217.9665625 364.97839844 218.183125 365.95679688 218.40625 366.96484375 C219.92614044 374.04411953 221.13311431 380.72082811 220.75 388 C221.41 388 222.07 388 222.75 388 C222.75 393.94 222.75 399.88 222.75 406 C222.09 406 221.43 406 220.75 406 C220.87375 407.8871875 220.87375 407.8871875 221 409.8125 C220.90352271 443.96546013 200.26607353 478.97769015 178.11230469 503.48632812 C176.85177965 504.8869115 175.61611802 506.30976466 174.3828125 507.734375 C156.48436495 528.24433981 132.41188536 545.49881841 107.75 557 C107.09 557 106.43 557 105.75 557 C105.42 557.66 105.09 558.32 104.75 559 C102.76470381 559.70925558 100.76009103 560.36440697 98.75 561 C97.36052917 561.55313654 95.97674018 562.12067166 94.59765625 562.69921875 C58.84685999 577.60889583 21.41173178 585.09844388 -17.25 586 C-19.20292969 586.061875 -19.20292969 586.061875 -21.1953125 586.125 C-30.27857622 586.28194624 -39.3136528 585.70444744 -48.375 585.125 C-49.62611572 585.04660889 -50.87723145 584.96821777 -52.16625977 584.88745117 C-60.60784983 584.30907776 -68.89199065 583.30970537 -77.25 582 C-77.25 582.33 -77.25 582.66 -77.25 583 C-80.88 583 -84.51 583 -88.25 583 C-88.25 582.01 -88.25 581.02 -88.25 580 C-97.61566806 577.38882467 -97.61566806 577.38882467 -107.25 577 C-107.58 576.34 -107.91 575.68 -108.25 575 C-110.49609892 574.30782342 -110.49609892 574.30782342 -113.125 573.875 C-114.00929688 573.70742188 -114.89359375 573.53984375 -115.8046875 573.3671875 C-118.33233538 572.92575253 -118.33233538 572.92575253 -121.25 573 C-121.25 572.01 -121.25 571.02 -121.25 570 C-122.41208984 569.88591797 -122.41208984 569.88591797 -123.59765625 569.76953125 C-128.60001836 568.71555763 -133.02153054 566.74524165 -137.6875 564.6875 C-138.68869873 564.24817139 -139.68989746 563.80884277 -140.72143555 563.35620117 C-148.11581136 560.06013551 -155.3721192 556.53149945 -162.5625 552.8125 C-163.48538818 552.3383667 -164.40827637 551.8642334 -165.35913086 551.37573242 C-170.84917563 548.48206801 -175.92982106 545.26930846 -180.94995117 541.61987305 C-183.31832944 539.9518771 -185.76021366 538.47851606 -188.25 537 C-189.31775633 536.15703448 -190.36144962 535.28241945 -191.375 534.375 C-194.44583734 531.67963622 -197.58058447 529.07894908 -200.75 526.5 C-214.60531216 515.18799172 -226.33873747 502.7994269 -236.6875 488.1875 C-237.170979 487.50719727 -237.65445801 486.82689453 -238.15258789 486.12597656 C-247.25 473.0524946 -247.25 473.0524946 -247.25 469 C-247.91 469 -248.57 469 -249.25 469 C-249.58 468.01 -249.91 467.02 -250.25 466 C-252.25016466 464.79117904 -252.25016466 464.79117904 -254.25 464 C-254.05543213 463.431604 -253.86086426 462.86320801 -253.66040039 462.27758789 C-253.16054301 459.50354296 -253.6546554 458.16440442 -254.68359375 455.55859375 C-255.00263672 454.72779297 -255.32167969 453.89699219 -255.65039062 453.04101562 C-255.99263672 452.18185547 -256.33488281 451.32269531 -256.6875 450.4375 C-257.3571619 448.72954326 -258.02271354 447.01996765 -258.68359375 445.30859375 C-258.98322021 444.55376709 -259.28284668 443.79894043 -259.59155273 443.02124023 C-260.25 441 -260.25 441 -260.25 438 C-261.57 437.67 -262.89 437.34 -264.25 437 C-264.745 433.535 -264.745 433.535 -265.25 430 C-264.59 430 -263.93 430 -263.25 430 C-263.91 429.34 -264.57 428.68 -265.25 428 C-265.41015625 425.75 -265.41015625 425.75 -265.3125 423 C-265.243572 419.43412455 -265.29551308 416.0362818 -265.75 412.5 C-266.98361969 401.46791534 -266.70603653 389.94888074 -265.46875 378.93359375 C-265.14733701 374.62321599 -265.21195941 370.32024874 -265.25 366 C-265.94859131 365.93006836 -266.64718262 365.86013672 -267.36694336 365.78808594 C-281.26386763 364.3683788 -294.75765831 362.66173576 -308.25 359 C-309.58257863 358.66366226 -310.91549165 358.32859753 -312.25 358 C-311.92 357.67 -311.59 357.34 -311.25 357 C-312.25417969 356.53851562 -313.25835937 356.07703125 -314.29296875 355.6015625 C-332.03741017 347.230061 -345.78202853 335.59603724 -357.69140625 319.8984375 C-359.12031794 317.89503946 -359.12031794 317.89503946 -361.25 317 C-361.60015049 315.33678518 -361.93197057 313.66965451 -362.25 312 C-363.24 310.515 -363.24 310.515 -364.25 309 C-364.91 309.33 -365.57 309.66 -366.25 310 C-366.35699219 308.97777344 -366.46398437 307.95554687 -366.57421875 306.90234375 C-367.25128378 302.99258673 -368.36944111 300.13292545 -370.0625 296.5625 C-379.25896628 276.08297425 -380.14763257 253.92856771 -378.25 231.875 C-378.15460938 230.72773438 -378.05921875 229.58046875 -377.9609375 228.3984375 C-377.72762017 225.59862951 -377.4905706 222.79919247 -377.25 220 C-376.59 220 -375.93 220 -375.25 220 C-375.13785156 219.17822266 -375.13785156 219.17822266 -375.0234375 218.33984375 C-372.0916846 200.66309835 -362.76174798 185.44133621 -351.25 172 C-350.56292969 171.17886719 -349.87585938 170.35773438 -349.16796875 169.51171875 C-331.45705738 148.9925908 -306.42681714 135.74338321 -279.31640625 133.56640625 C-269.87225186 132.93519117 -260.66381839 132.88339745 -251.25 134 C-250.88068359 132.72189453 -250.88068359 132.72189453 -250.50390625 131.41796875 C-248.91195406 127.07853522 -246.57040136 123.46884707 -244.08398438 119.59179688 C-242.48041041 117.0634261 -241.20200999 114.85602998 -240.25 112 C-238.9181844 110.66515066 -237.58447342 109.33219227 -236.25 108 C-234.32881346 105.54936419 -232.51740956 103.01921219 -230.6875 100.5 C-225.98023555 94.10682372 -220.99644745 88.20331332 -215.52734375 82.453125 C-213.25111776 80.10112136 -213.25111776 80.10112136 -211.56640625 77.671875 C-211.13199219 77.12015625 -210.69757813 76.5684375 -210.25 76 C-209.59 76 -208.93 76 -208.25 76 C-207.92 75.01 -207.59 74.02 -207.25 73 C-205.71875 71.45703125 -205.71875 71.45703125 -203.75 69.8125 C-200.80339434 67.31961946 -197.91267367 64.79006154 -195.0625 62.1875 C-156.16785859 27.68097198 -107.25742006 8.36855543 -56.25 1 C-55.07050781 0.81308594 -53.89101563 0.62617188 -52.67578125 0.43359375 C-48.32914027 -0.11655123 -43.99969494 -0.35690956 -39.625 -0.5625 C-38.81160156 -0.60568359 -37.99820312 -0.64886719 -37.16015625 -0.69335938 C-24.71781237 -1.30289877 -12.4131633 -0.86347401 0 0 Z M-263.25 365 C-263.58 365.99 -263.91 366.98 -264.25 368 C-263.59 368 -262.93 368 -262.25 368 C-262.58 367.01 -262.91 366.02 -263.25 365 Z M-264.25 369 C-263.25 373 -263.25 373 -263.25 373 Z M-263.25 431 C-262.25 433 -262.25 433 -262.25 433 Z M-262.25 434 C-261.25 437 -261.25 437 -261.25 437 Z ",
    fill: "#727171",
    transform: "translate(521.25,215)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.27439346 3.42970924 8.31852983 7.06857103 12.29296875 10.83984375 C13.07929688 11.58492188 13.865625 12.33 14.67578125 13.09765625 C19.14559272 17.4462525 23.06114517 21.91529074 26.6875 26.9921875 C29.13962056 29.81421432 31.20165553 30.68323536 34.87890625 31.2109375 C39.42500268 31.31917789 42.42344838 31.34416557 46.41796875 29.02734375 C49.92817023 25.47667885 52.96141885 21.41978982 56.08984375 17.53515625 C70.15592845 0.32664837 91.26574123 -13.26839868 113.29296875 -17.16015625 C136.84105214 -18.7482828 158.74313586 -15.04085352 177.0625 0.79296875 C177.79855469 1.4684375 178.53460937 2.14390625 179.29296875 2.83984375 C180.05996094 3.5153125 180.82695313 4.19078125 181.6171875 4.88671875 C197.47156267 19.63747867 206.89399923 43.43272679 207.77182007 64.9009552 C207.8608619 68.96573804 207.84490998 73.02467284 207.79296875 77.08984375 C207.78742981 77.9422464 207.78189087 78.79464905 207.77618408 79.67288208 C207.67709751 92.69362045 207.07226743 105.29141374 203.29296875 117.83984375 C202.97948486 118.88906006 202.97948486 118.88906006 202.65966797 119.95947266 C197.15034738 137.60167904 187.76308824 152.50214036 175.88867188 166.49462891 C172.33303582 170.71216421 170.71484198 173.21968525 170.7421875 178.8984375 C171.61792466 183.57524661 173.92744254 187.43548618 176.15039062 191.60400391 C186.77443435 211.80950092 187.53394587 239.0782344 181.29296875 260.83984375 C170.93770129 292.55932738 147.86187552 315.7906414 118.68530273 330.91113281 C101.75030126 339.28254092 83.86916856 343.89036824 65.29296875 346.83984375 C64.4119751 347.01418945 63.53098145 347.18853516 62.62329102 347.36816406 C58.29432642 347.98128331 54.0392231 348.04053208 49.671875 348.078125 C48.7432515 348.08791885 47.81462799 348.09771271 46.85786438 348.10780334 C8.00469494 348.43332689 8.00469494 348.43332689 -8.70703125 343.83984375 C-9.53686523 343.61490234 -10.36669922 343.38996094 -11.22167969 343.15820312 C-16.7985925 341.60155618 -22.2588506 339.79579306 -27.70703125 337.83984375 C-28.69558105 337.49614746 -28.69558105 337.49614746 -29.70410156 337.14550781 C-44.98818333 331.78089633 -58.60615194 323.58343644 -70.70703125 312.83984375 C-71.53332031 312.15664063 -72.35960937 311.4734375 -73.2109375 310.76953125 C-92.22246596 294.64394686 -105.94629537 270.21551984 -108.00830078 245.18237305 C-108.14373255 241.3335622 -108.17463425 237.50337815 -108.14453125 233.65234375 C-108.14148987 232.97519318 -108.13844849 232.2980426 -108.13531494 231.60037231 C-108.0217748 214.46312802 -105.41980295 197.4090013 -95.70703125 182.83984375 C-95.31612932 180.76331252 -95.31612932 180.76331252 -95.33203125 178.52734375 C-95.30367188 177.78871094 -95.2753125 177.05007813 -95.24609375 176.2890625 C-96.30043558 170.68675463 -100.81270594 166.44974805 -104.45703125 162.27734375 C-109.61077843 156.21243158 -113.79953645 149.78196917 -117.70703125 142.83984375 C-118.31417969 141.77378906 -118.92132813 140.70773437 -119.546875 139.609375 C-135.2920624 110.22065541 -138.05362557 73.29347859 -128.8984375 41.40234375 C-121.60037037 19.57992663 -107.33514509 0.8594678 -86.58203125 -9.53515625 C-57.74956196 -23.50504177 -25.51090126 -18.84473611 0 0 Z ",
    fill: "#D7D7D7",
    transform: "translate(460.70703125,385.16015625)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C12.36239415 0.85779653 12.36239415 0.85779653 24.75 1 C24.42 1.66 24.09 2.32 23.75 3 C27.38 3.66 31.01 4.32 34.75 5 C35.08 4.34 35.41 3.68 35.75 3 C35.75 3.99 35.75 4.98 35.75 6 C36.86375 6.12375 37.9775 6.2475 39.125 6.375 C46.82519407 7.33580853 54.0756465 8.89326296 61.2734375 11.80859375 C66.61708739 13.95672161 71.99037134 16.01964746 77.375 18.0625 C78.70917969 18.57006836 78.70917969 18.57006836 80.0703125 19.08789062 C89.36364427 22.67363775 89.36364427 22.67363775 98.75 26 C100.0850765 26.99767155 101.41808243 27.9981151 102.75 29 C104.84174491 30.20924639 106.94766872 31.39409841 109.0625 32.5625 C120.17344143 38.81983018 130.67060413 45.89648386 140.62719727 53.86474609 C143.01953282 55.76425821 144.81938676 57.02312892 147.75 58 C148.5853125 59.051875 148.5853125 59.051875 149.4375 60.125 C152.47851292 63.90571876 156.01402011 66.92073533 159.75 70 C160.430625 70.56460938 161.11125 71.12921875 161.8125 71.7109375 C163.77842626 73.27696262 163.77842626 73.27696262 166.75 73 C166.42 73.66 166.09 74.32 165.75 75 C166.08 75.33 166.41 75.66 166.75 76 C176.14726062 86.03102936 184.70224971 96.72654969 192.41015625 108.109375 C193.74947773 110.1115247 193.74947773 110.1115247 195.75 112 C197.14221805 114.29758685 198.49125806 116.59991811 199.8125 118.9375 C200.17666016 119.57107422 200.54082031 120.20464844 200.91601562 120.85742188 C202.44613804 123.54715647 203.76886389 126.05659166 204.75 129 C205.41 129.33 206.07 129.66 206.75 130 C207.875 132.0625 207.875 132.0625 208.75 134 C210.3754308 133.85904936 212.00034051 133.71207913 213.625 133.5625 C214.52992188 133.48128906 215.43484375 133.40007812 216.3671875 133.31640625 C218.76110861 133.13010715 218.76110861 133.13010715 220.75 132 C222.70003732 132.20952529 224.64989041 132.42680436 226.59179688 132.70166016 C228.49701696 132.96502881 230.41263505 133.15065361 232.328125 133.32421875 C260.00467013 136.06243013 285.72460012 148.47707312 304.75 169 C304.75 169.66 304.75 170.32 304.75 171 C305.41 171 306.07 171 306.75 171 C308.62946652 173.31800871 310.38976326 175.64001818 312.125 178.0625 C312.60710938 178.71927734 313.08921875 179.37605469 313.5859375 180.05273438 C315.8976096 183.24070609 318.05299078 186.43308813 319.9765625 189.87109375 C321.55859023 192.98625355 321.55859023 192.98625355 323.75 195 C324.58789063 196.75244141 324.58789063 196.75244141 325.40625 198.8515625 C325.70660156 199.62113281 326.00695312 200.39070312 326.31640625 201.18359375 C326.77853516 202.39208984 326.77853516 202.39208984 327.25 203.625 C327.71212891 204.79869141 327.71212891 204.79869141 328.18359375 205.99609375 C330.59645728 212.24054315 332.75 218.23469794 332.75 225 C333.41 225.33 334.07 225.66 334.75 226 C339.4060758 251.95981887 334.9185898 280.5578848 322.51953125 303.64453125 C320.5582822 307.36354435 319.07676116 311.01971652 317.75 315 C317.09 315 316.43 315 315.75 315 C314.58891728 316.52068314 313.49826529 318.09521634 312.4375 319.6875 C295.81802078 343.05111571 269.90172852 358.77130022 241.74609375 363.54296875 C235.43035543 364.37287646 229.10414522 364.24649701 222.75 364 C222.75 364.66 222.75 365.32 222.75 366 C221.76 366.33 220.77 366.66 219.75 367 C219.75 366.34 219.75 365.68 219.75 365 C219.09 364.67 218.43 364.34 217.75 364 C217.9665625 364.97839844 218.183125 365.95679688 218.40625 366.96484375 C219.92614044 374.04411953 221.13311431 380.72082811 220.75 388 C221.41 388 222.07 388 222.75 388 C222.75 393.94 222.75 399.88 222.75 406 C222.09 406 221.43 406 220.75 406 C220.87375 407.8871875 220.87375 407.8871875 221 409.8125 C220.90352271 443.96546013 200.26607353 478.97769015 178.11230469 503.48632812 C176.85177965 504.8869115 175.61611802 506.30976466 174.3828125 507.734375 C156.48436495 528.24433981 132.41188536 545.49881841 107.75 557 C107.09 557 106.43 557 105.75 557 C105.42 557.66 105.09 558.32 104.75 559 C102.76470381 559.70925558 100.76009103 560.36440697 98.75 561 C97.36052917 561.55313654 95.97674018 562.12067166 94.59765625 562.69921875 C58.84685999 577.60889583 21.41173178 585.09844388 -17.25 586 C-19.20292969 586.061875 -19.20292969 586.061875 -21.1953125 586.125 C-30.27857622 586.28194624 -39.3136528 585.70444744 -48.375 585.125 C-49.62611572 585.04660889 -50.87723145 584.96821777 -52.16625977 584.88745117 C-60.60784983 584.30907776 -68.89199065 583.30970537 -77.25 582 C-77.25 582.33 -77.25 582.66 -77.25 583 C-80.88 583 -84.51 583 -88.25 583 C-88.25 582.01 -88.25 581.02 -88.25 580 C-97.61566806 577.38882467 -97.61566806 577.38882467 -107.25 577 C-107.58 576.34 -107.91 575.68 -108.25 575 C-110.49609892 574.30782342 -110.49609892 574.30782342 -113.125 573.875 C-114.00929688 573.70742188 -114.89359375 573.53984375 -115.8046875 573.3671875 C-118.33233538 572.92575253 -118.33233538 572.92575253 -121.25 573 C-121.25 572.01 -121.25 571.02 -121.25 570 C-122.41208984 569.88591797 -122.41208984 569.88591797 -123.59765625 569.76953125 C-128.60001836 568.71555763 -133.02153054 566.74524165 -137.6875 564.6875 C-138.68869873 564.24817139 -139.68989746 563.80884277 -140.72143555 563.35620117 C-148.11581136 560.06013551 -155.3721192 556.53149945 -162.5625 552.8125 C-163.48538818 552.3383667 -164.40827637 551.8642334 -165.35913086 551.37573242 C-170.84917563 548.48206801 -175.92982106 545.26930846 -180.94995117 541.61987305 C-183.31832944 539.9518771 -185.76021366 538.47851606 -188.25 537 C-189.31775633 536.15703448 -190.36144962 535.28241945 -191.375 534.375 C-194.44583734 531.67963622 -197.58058447 529.07894908 -200.75 526.5 C-214.60531216 515.18799172 -226.33873747 502.7994269 -236.6875 488.1875 C-237.170979 487.50719727 -237.65445801 486.82689453 -238.15258789 486.12597656 C-247.25 473.0524946 -247.25 473.0524946 -247.25 469 C-247.91 469 -248.57 469 -249.25 469 C-249.58 468.01 -249.91 467.02 -250.25 466 C-252.25016466 464.79117904 -252.25016466 464.79117904 -254.25 464 C-254.05543213 463.431604 -253.86086426 462.86320801 -253.66040039 462.27758789 C-253.16054301 459.50354296 -253.6546554 458.16440442 -254.68359375 455.55859375 C-255.00263672 454.72779297 -255.32167969 453.89699219 -255.65039062 453.04101562 C-255.99263672 452.18185547 -256.33488281 451.32269531 -256.6875 450.4375 C-257.3571619 448.72954326 -258.02271354 447.01996765 -258.68359375 445.30859375 C-258.98322021 444.55376709 -259.28284668 443.79894043 -259.59155273 443.02124023 C-260.25 441 -260.25 441 -260.25 438 C-261.57 437.67 -262.89 437.34 -264.25 437 C-264.745 433.535 -264.745 433.535 -265.25 430 C-264.59 430 -263.93 430 -263.25 430 C-263.91 429.34 -264.57 428.68 -265.25 428 C-265.41015625 425.75 -265.41015625 425.75 -265.3125 423 C-265.243572 419.43412455 -265.29551308 416.0362818 -265.75 412.5 C-266.98361969 401.46791534 -266.70603653 389.94888074 -265.46875 378.93359375 C-265.14733701 374.62321599 -265.21195941 370.32024874 -265.25 366 C-265.94859131 365.93006836 -266.64718262 365.86013672 -267.36694336 365.78808594 C-281.26386763 364.3683788 -294.75765831 362.66173576 -308.25 359 C-309.58257863 358.66366226 -310.91549165 358.32859753 -312.25 358 C-311.92 357.67 -311.59 357.34 -311.25 357 C-312.25417969 356.53851562 -313.25835937 356.07703125 -314.29296875 355.6015625 C-332.03741017 347.230061 -345.78202853 335.59603724 -357.69140625 319.8984375 C-359.12031794 317.89503946 -359.12031794 317.89503946 -361.25 317 C-361.60015049 315.33678518 -361.93197057 313.66965451 -362.25 312 C-363.24 310.515 -363.24 310.515 -364.25 309 C-364.91 309.33 -365.57 309.66 -366.25 310 C-366.35699219 308.97777344 -366.46398437 307.95554687 -366.57421875 306.90234375 C-367.25128378 302.99258673 -368.36944111 300.13292545 -370.0625 296.5625 C-379.25896628 276.08297425 -380.14763257 253.92856771 -378.25 231.875 C-378.15460938 230.72773438 -378.05921875 229.58046875 -377.9609375 228.3984375 C-377.72762017 225.59862951 -377.4905706 222.79919247 -377.25 220 C-376.59 220 -375.93 220 -375.25 220 C-375.13785156 219.17822266 -375.13785156 219.17822266 -375.0234375 218.33984375 C-372.0916846 200.66309835 -362.76174798 185.44133621 -351.25 172 C-350.56292969 171.17886719 -349.87585938 170.35773438 -349.16796875 169.51171875 C-331.45705738 148.9925908 -306.42681714 135.74338321 -279.31640625 133.56640625 C-269.87225186 132.93519117 -260.66381839 132.88339745 -251.25 134 C-250.88068359 132.72189453 -250.88068359 132.72189453 -250.50390625 131.41796875 C-248.91195406 127.07853522 -246.57040136 123.46884707 -244.08398438 119.59179688 C-242.48041041 117.0634261 -241.20200999 114.85602998 -240.25 112 C-238.9181844 110.66515066 -237.58447342 109.33219227 -236.25 108 C-234.32881346 105.54936419 -232.51740956 103.01921219 -230.6875 100.5 C-225.98023555 94.10682372 -220.99644745 88.20331332 -215.52734375 82.453125 C-213.25111776 80.10112136 -213.25111776 80.10112136 -211.56640625 77.671875 C-211.13199219 77.12015625 -210.69757813 76.5684375 -210.25 76 C-209.59 76 -208.93 76 -208.25 76 C-207.92 75.01 -207.59 74.02 -207.25 73 C-205.71875 71.45703125 -205.71875 71.45703125 -203.75 69.8125 C-200.80339434 67.31961946 -197.91267367 64.79006154 -195.0625 62.1875 C-156.16785859 27.68097198 -107.25742006 8.36855543 -56.25 1 C-55.07050781 0.81308594 -53.89101563 0.62617188 -52.67578125 0.43359375 C-48.32914027 -0.11655123 -43.99969494 -0.35690956 -39.625 -0.5625 C-38.81160156 -0.60568359 -37.99820312 -0.64886719 -37.16015625 -0.69335938 C-24.71781237 -1.30289877 -12.4131633 -0.86347401 0 0 Z M-198.25 105 C-202.1975587 109.46638707 -205.78528551 114.15344413 -209.25 119 C-209.9291748 119.93658447 -209.9291748 119.93658447 -210.62207031 120.89208984 C-221.73506941 136.2902185 -230.47398666 152.25346429 -237.25 170 C-237.56211426 170.8156543 -237.87422852 171.63130859 -238.19580078 172.47167969 C-252.28579495 210.05974367 -255.26576157 254.81425315 -246.25 294 C-245.93651611 295.43666016 -245.93651611 295.43666016 -245.61669922 296.90234375 C-242.15938122 312.50300566 -236.80681773 327.234639 -229.984375 341.6796875 C-227.73707909 348.78018627 -230.2965426 355.52489116 -232.296875 362.35742188 C-239.89369733 389.41551551 -238.8989872 420.27903627 -227.25 446 C-226.83258545 446.9290918 -226.83258545 446.9290918 -226.40673828 447.87695312 C-211.7430328 480.0752464 -185.57880955 504.19628097 -156.25 523 C-154.89455078 523.88945313 -154.89455078 523.88945313 -153.51171875 524.796875 C-120.00735886 545.64403227 -76.89455934 556.9129866 -37.546875 557.23828125 C-36.06425423 557.25297203 -36.06425423 557.25297203 -34.55168152 557.26795959 C4.02216403 557.57128343 39.42723828 553.83231477 75.75 540 C76.80703125 539.60296875 77.8640625 539.2059375 78.953125 538.796875 C81.93160304 537.61546751 84.8379763 536.33747869 87.75 535 C88.79196533 534.52385254 88.79196533 534.52385254 89.85498047 534.03808594 C108.86992446 525.24232866 126.20553417 514.05390061 141.75 500 C142.71164062 499.16984375 143.67328125 498.3396875 144.6640625 497.484375 C151.1132157 491.83470361 156.5266367 485.78662794 161.75 479 C162.48992187 478.07574219 163.22984375 477.15148437 163.9921875 476.19921875 C170.18619581 468.27988979 175.08224935 459.88386099 179.75 451 C180.47509766 449.65035156 180.47509766 449.65035156 181.21484375 448.2734375 C195.83321454 418.84987967 194.92358713 383.21306643 185.51953125 352.39453125 C183.90622878 345.27798381 184.43916595 340.68431955 187.875 334.125 C192.08934181 325.68987407 194.99970129 317.00323857 197.75 308 C198.11996094 306.824375 198.48992187 305.64875 198.87109375 304.4375 C199.97662477 300.65202412 200.90822408 296.85065908 201.75 293 C201.93336914 292.18354004 202.11673828 291.36708008 202.30566406 290.52587891 C205.57289328 275.27604506 206.14873291 260.22242687 206.1875 244.6875 C206.19662415 243.31049423 206.19662415 243.31049423 206.20593262 241.90567017 C206.28032406 224.73792722 204.88139398 207.5539023 200.0625 191 C199.8054126 190.09741455 199.5483252 189.1948291 199.28344727 188.26489258 C191.74009806 162.51361351 180.21870937 138.25850983 163.75 117 C163.00492188 116.02546875 162.25984375 115.0509375 161.4921875 114.046875 C142.63252755 90.24612332 119.74667885 71.4912114 93.75 56 C93.13012207 55.62536621 92.51024414 55.25073242 91.87158203 54.86474609 C68.15402853 40.70332651 39.97927492 32.78430062 12.75 29 C11.68507324 28.8455542 11.68507324 28.8455542 10.59863281 28.68798828 C-68.0884509 17.71202442 -144.78228457 47.1673149 -198.25 105 Z M-263.25 365 C-263.58 365.99 -263.91 366.98 -264.25 368 C-263.59 368 -262.93 368 -262.25 368 C-262.58 367.01 -262.91 366.02 -263.25 365 Z M-264.25 369 C-263.25 373 -263.25 373 -263.25 373 Z M-263.25 431 C-262.25 433 -262.25 433 -262.25 433 Z M-262.25 434 C-261.25 437 -261.25 437 -261.25 437 Z ",
    fill: "#323232",
    transform: "translate(521.25,215)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.77370972 0.01522705 1.77370972 0.01522705 3.58325195 0.03076172 C32.05881814 0.53551583 56.7704064 13.04016425 77.359375 32.265625 C80.22846357 34.93684539 83.21948521 37.45102222 86.2265625 39.96484375 C87.625 41.375 87.625 41.375 87.625 43.375 C91.6640876 41.1895651 94.48077655 38.64365137 97.625 35.3125 C111.26552963 21.31300906 128.0559211 10.52360744 146.625 4.375 C147.85863281 3.96121094 149.09226562 3.54742187 150.36328125 3.12109375 C176.02011692 -4.55273226 203.49761675 -0.01642475 226.66894531 12.47705078 C252.64404708 27.01793001 269.77128976 49.75706056 278.02734375 78.18359375 C283.81359412 99.3998451 284.7091283 122.7641268 280.625 144.375 C280.50141113 145.0565918 280.37782227 145.73818359 280.25048828 146.44042969 C275.93829177 169.74197156 266.58124628 194.56167256 250.6875 212.5703125 C247.5155246 215.97470106 247.5155246 215.97470106 246.75 220.3359375 C247.54708318 222.77247587 248.56607957 225.03985624 249.625 227.375 C260.94919272 257.17739924 261.91200703 291.33132835 249.3125 320.875 C232.28610084 358.23045329 197.99864425 383.77447281 160.359375 398.03125 C152.07888458 401.01304834 143.64786149 403.2108796 135.0625 405.125 C134.17804199 405.32375732 133.29358398 405.52251465 132.38232422 405.72729492 C118.32924329 408.69326541 104.36975975 409.71115663 90.04101562 409.63574219 C87.62604696 409.62500466 85.21182171 409.63572725 82.796875 409.6484375 C67.98546061 409.66375855 53.66070454 408.26875996 39.25 404.6875 C37.65865234 404.29667236 37.65865234 404.29667236 36.03515625 403.89794922 C26.27237838 401.42054154 16.91067754 398.26458196 7.625 394.375 C6.90940918 394.07899902 6.19381836 393.78299805 5.45654297 393.47802734 C-28.38160636 379.23969718 -57.39459168 352.43250272 -71.60498047 318.33105469 C-77.16091475 304.21750191 -79.73745613 290.47028964 -79.69067383 275.32495117 C-79.6875299 273.20763781 -79.71100407 271.09174969 -79.73632812 268.97460938 C-79.80760108 253.56792135 -77.16094508 238.47802698 -70.5625 224.4375 C-69.19227331 220.90375749 -69.24851671 219.92854273 -70.375 216.375 C-71.83849517 214.14124421 -73.32069582 212.05214886 -74.9375 209.9375 C-99.91194233 175.92043311 -109.02677402 132.14926237 -103.125 90.5703125 C-98.40888929 62.12792569 -83.17236138 36.5316254 -59.71484375 19.65234375 C-41.88304818 7.30242608 -21.89077686 -0.27400872 0 0 Z M-61.921875 51.328125 C-72.5677732 64.97488041 -79.1492831 81.21627556 -81.375 98.375 C-81.48585938 99.21933594 -81.59671875 100.06367188 -81.7109375 100.93359375 C-85.39556809 134.44381524 -77.98153166 170.39112213 -56.90087891 197.25341797 C-54.56991149 200.09515815 -52.17038983 202.86422455 -49.72265625 205.60546875 C-45.75099462 210.29083996 -43.69351196 213.65493273 -43.88671875 219.796875 C-44.68687545 224.02170238 -46.75808453 227.50559107 -48.78125 231.265625 C-59.03585978 251.27216762 -60.03326858 279.76849536 -53.56933594 301.19360352 C-52.88144754 303.27303087 -52.14299886 305.32396147 -51.375 307.375 C-51.14506348 308.01663086 -50.91512695 308.65826172 -50.67822266 309.31933594 C-40.55927125 337.06230674 -17.10923421 358.10728772 8.625 371.375 C13.54729627 373.61394162 18.53714386 375.55628574 23.625 377.375 C24.3351123 377.63168457 25.04522461 377.88836914 25.77685547 378.15283203 C31.33183865 380.12671495 36.93552048 381.83276439 42.625 383.375 C43.40584961 383.58962891 44.18669922 383.80425781 44.99121094 384.02539062 C72.01306497 391.02241818 106.71307377 390.59114885 133.625 383.375 C134.4819043 383.15537598 135.33880859 382.93575195 136.22167969 382.70947266 C170.61084634 373.74086939 204.11559747 354.62021614 222.55517578 323.27050781 C235.64371272 300.08032051 239.45072531 273.11038492 233.67578125 247.02734375 C231.44150224 239.26135537 228.64175967 231.6716396 224.46484375 224.7265625 C222.05616701 220.33878194 221.76387391 217.24574447 222.625 212.375 C224.16809762 209.28880477 226.02493389 207.02518449 228.35546875 204.5 C249.88638485 181.12112104 259.23440699 150.72312259 259.07104492 119.36376953 C259.06250272 116.87579206 259.09150369 114.3900989 259.12304688 111.90234375 C259.23326298 86.96844904 250.72463061 62.83964249 233.4375 44.5625 C215.49723057 27.52551686 194.89350603 21.45803371 170.6015625 22.03515625 C146.58885201 23.08454531 123.93449882 39.08555823 107.99169922 56.18310547 C105.04989423 59.40833684 102.18485699 62.65533116 99.50390625 66.1015625 C97.27715034 68.79589086 95.65558461 70.23586299 92.13671875 70.7109375 C86.06587972 70.79490484 82.24939985 70.69110652 77.625 66.375 C75.7036426 64.04702976 73.85462088 61.66966333 72.00390625 59.28515625 C57.30971233 41.3095003 36.31657147 25.31379324 12.625 22.375 C8.39410332 22.07345349 4.17842684 21.96971828 -0.0625 21.9375 C-1.61203369 21.9221521 -1.61203369 21.9221521 -3.19287109 21.90649414 C-26.48865517 22.1715138 -46.95973073 33.97938104 -61.921875 51.328125 Z ",
    fill: "#303030",
    transform: "translate(409.375,345.625)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.29132813 1.04671875 -0.58265625 2.0934375 -0.8828125 3.171875 C-3.58471402 13.05464667 -5.98450493 22.99433235 -8.1875 33 C-8.43709473 34.10053711 -8.68668945 35.20107422 -8.94384766 36.33496094 C-12.43876505 52.51574505 -13.38895342 68.73831015 -13.3125 85.25 C-13.31034485 86.09817291 -13.3081897 86.94634583 -13.30596924 87.82022095 C-13.19430215 115.34680432 -8.25699411 141.95835792 -0.6640625 168.41015625 C0 171 0 171 0 174 C-21.81202338 175.25677471 -40.75732406 169.7246732 -57.5078125 155.3046875 C-73.45173851 140.56030452 -83.83798956 120.35292956 -85.21582031 98.59130859 C-86.25269631 70.53225046 -82.41154692 48.21336632 -63.25 26.91015625 C-49.65323161 12.30205798 -30.99137358 2.16754814 -10.875 0.375 C-10.08867187 0.30023438 -9.30234375 0.22546875 -8.4921875 0.1484375 C-5.65681439 -0.02044052 -2.83973049 -0.02469331 0 0 Z ",
    fill: "#8E8E8D",
    transform: "translate(258,376)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C17.63271702 -1.78308374 37.02100406 5.9724953 50.9375 16.5 C52.30317249 17.65317696 53.65758706 18.819828 55 20 C56.10021484 20.88751953 56.10021484 20.88751953 57.22265625 21.79296875 C71.72868522 33.86059147 82.96184849 53.0763294 85 72 C86.05067652 87.65695642 85.97572697 103.02080802 81 118 C80.58427734 119.36125 80.58427734 119.36125 80.16015625 120.75 C73.03306927 141.24448054 55.85093522 157.62763313 36.9296875 167.203125 C26.94842105 171.97310926 16.14687959 174.20134151 5.125 174.0625 C4.43664062 174.05798828 3.74828125 174.05347656 3.0390625 174.04882812 C1.35933665 174.03716336 -0.32034375 174.01923271 -2 174 C-1.82331787 173.36400879 -1.64663574 172.72801758 -1.46459961 172.07275391 C1.68075656 160.65688291 4.54396452 149.17853822 7.171875 137.63330078 C7.67435625 135.42872356 8.18508464 133.22597504 8.7109375 131.02685547 C12.35071806 115.39208821 12.38854327 99.72290029 12.4375 83.75 C12.44385468 82.68544586 12.45020935 81.62089172 12.45675659 80.52407837 C12.5272876 61.49847657 10.70555086 43.27933631 6 24.8125 C5.7525 23.79865234 5.505 22.78480469 5.25 21.74023438 C3.86034839 16.12010689 2.31286355 10.58016428 0.55078125 5.06518555 C0 3 0 3 0 0 Z ",
    fill: "#8E8E8E",
    transform: "translate(741,376)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.88945312 0.41507813 1.77890625 0.83015625 2.6953125 1.2578125 C7.52005224 2.81154225 11.51392143 0.40378671 15.87548828 -1.5793457 C23.37828781 -4.95217152 30.65601186 -8.09563955 39 -6 C42.5258282 -3.97738452 45.17316695 -1.6536661 47 2 C47.55004295 7.72044663 46.64364029 10.56854559 43 15 C39.3050633 18.35666785 35.90668004 19.98597128 31.1875 21.5625 C26.07873127 23.29188342 21.0580342 25.10323717 16 27 C15.67 51.42 15.34 75.84 15 101 C49.48357261 95.84548666 49.48357261 95.84548666 76.3125 74.8125 C76.77398438 74.15765625 77.23546875 73.5028125 77.7109375 72.828125 C80.54023372 68.81566854 82.66635951 66.38796814 87.4375 65 C91.55333147 65 93.60229091 65.70852177 97 68 C99.59851944 72.24156953 99.84233378 76.15847789 99 81 C94.09332857 92.90287595 83.89183079 100.84181229 73 107 C71.61167969 107.78697266 71.61167969 107.78697266 70.1953125 108.58984375 C50.08215191 119.30051057 27.60608726 122.23257257 5.125 122.25 C3.95365005 122.25101212 3.95365005 122.25101212 2.75863647 122.25204468 C-15.10433926 122.22752619 -31.14207671 120.02974055 -48 114 C-49.56814453 113.46439453 -49.56814453 113.46439453 -51.16796875 112.91796875 C-65.09628875 107.7109482 -80.38523282 96.8184707 -87.1875 83.33203125 C-88.63016115 79.1913163 -88.83257026 75.29786269 -88 71 C-86.20353146 68.06576805 -85.0558929 66.52794645 -82 65 C-76.8951527 64.61472851 -74.14808134 65.01836175 -70 68 C-68.296875 70.19921875 -68.296875 70.19921875 -66.75 72.6875 C-56.47474896 87.81495293 -39.45761199 95.37353954 -22 99 C-16.39 99.66 -10.78 100.32 -5 101 C-5 76.25 -5 51.5 -5 26 C-8.63 25.01 -12.26 24.02 -16 23 C-24.91476168 20.11526501 -30.74991558 17.87512663 -36 10 C-36.42740092 4.70022855 -36.52351458 1.25251759 -33 -3 C-23.96789576 -11.18534447 -9.54191259 -3.85693067 0 0 Z ",
    fill: "#2F2F2F",
    transform: "translate(493,545)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C15.31190934 4.02322193 25.01484571 10.92873983 34 24 C40.8188792 36.01722229 42.14012961 51.54557458 38.8125 64.875 C34.25261211 78.93290321 25.88315129 89.56210102 13 97 C7.71223426 99.63216699 3.01792448 101.63346573 -3 101 C-2.58312176 96.2227348 -2.1422915 91.478268 -1.25488281 86.76245117 C1.5419391 71.7033763 1.38834031 56.66112646 1.26428223 41.41046143 C1.24509335 38.59174733 1.24112123 35.77309832 1.2375679 32.95432758 C1.23239226 29.54894387 1.21787498 26.14363782 1.203125 22.73828125 C1.19887512 21.49129959 1.19462524 20.24431793 1.19024658 18.95954895 C1.13797338 12.56082184 0.8489564 6.34377991 0 0 Z ",
    fill: "#666767",
    transform: "translate(752,414)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.13277344 1.18335938 -0.26554687 2.36671875 -0.40234375 3.5859375 C-0.58075943 5.18228829 -0.75914312 6.77864265 -0.9375 8.375 C-1.02451172 9.14972656 -1.11152344 9.92445313 -1.20117188 10.72265625 C-1.38104393 12.33484283 -1.55749391 13.947414 -1.73095703 15.56030273 C-1.90079653 17.10041715 -2.08248736 18.63931294 -2.28076172 20.17602539 C-3.33356249 28.97823943 -3.24004045 37.83545425 -3.25 46.6875 C-3.25200409 47.55250122 -3.25400818 48.41750244 -3.256073 49.30871582 C-3.26341199 62.25349139 -2.53304989 74.78226045 -0.36376953 87.56445312 C0.30181235 92.02072485 0.64354297 96.51002264 1 101 C-9.72128151 100.81828336 -18.4852541 95.69131473 -26.3125 88.5625 C-37.65400288 76.46243004 -41.75164226 61.50036751 -41.30859375 45.2890625 C-40.58536635 31.77881462 -33.89770905 19.95117184 -24.1640625 10.78125 C-17.47274921 5.27359862 -8.91390886 0 0 0 Z ",
    fill: "#666767",
    transform: "translate(248,414)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.38125595 4.11977076 10.49520988 9.43194247 13.1875 17.3125 C16.52225127 29.48854559 14.90572615 40.23698488 9 51.4375 C3.45303844 57.93536925 -1.35783252 61.53261282 -10.0625 62.375 C-16.03330989 62.20375306 -20.46287986 59.45024875 -24.9375 55.6875 C-33.23027379 45.78224242 -34.01077937 35.57134537 -33.1875 23 C-31.80829554 13.70485736 -28.09270204 6.69683069 -20.5 1.0625 C-13.71448846 -3.16244115 -7.24938579 -3.26331868 0 0 Z ",
    fill: "#313131",
    transform: "translate(592.1875,458)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.22704574 4.3014681 10.41056182 11.475942 12.94921875 19.16015625 C13.44421875 20.64515625 13.44421875 20.64515625 13.94921875 22.16015625 C14.96090034 33.15246587 13.42093717 45.31367797 6.6953125 54.3203125 C1.87762832 59.39666429 -3.41201121 61.81027452 -10.30078125 62.47265625 C-16.83890576 61.92781254 -21.27800547 59.304049 -25.80078125 54.59765625 C-33.67943409 44.73581848 -34.332873 33.29710066 -33.05078125 21.16015625 C-31.38440491 12.40126562 -26.68727038 5.0037752 -19.2578125 -0.0625 C-13.06448741 -3.10955925 -6.20410177 -2.62059308 0 0 Z ",
    fill: "#313131",
    transform: "translate(423.05078125,457.83984375)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 2 1 2 0.44140625 4.07421875 C0.15136719 4.93660156 -0.13867188 5.79898437 -0.4375 6.6875 C-3.34634771 16.90197904 -3.38010214 28.19516885 1 38 C2.22824527 40.10870783 3.5648095 42.02042689 5 44 C5 44.66 5 45.32 5 46 C6.32258472 46.68774405 7.65986503 47.34711373 9 48 C10.0725 48.53625 11.145 49.0725 12.25 49.625 C19.30175957 52.21064518 25.01208558 50.99654698 32 49 C29.33861783 51.91484713 27.36810053 52.87636425 23.36328125 53.23828125 C16.70353371 53.40029816 11.36236769 53.24420582 6 49 C-1.18490006 41.89864529 -5.01502955 31.02540572 -5.25 21 C-5.17863371 13.93473729 -3.94606289 5.91909433 0 0 Z ",
    fill: "#EEEFEF",
    transform: "translate(562,468)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 24.75 1.66 49.5 2 75 C-2.95 75.495 -2.95 75.495 -8 76 C-8.66 75.34 -9.32 74.68 -10 74 C-12.57061311 73.35232207 -12.57061311 73.35232207 -15 73 C-15 72.67 -15 72.34 -15 72 C-10.05 72.33 -5.1 72.66 0 73 C-0.03552979 70.85967285 -0.07105957 68.7193457 -0.10766602 66.51416016 C-0.22412613 59.45346918 -0.33494431 52.39269785 -0.4429636 45.33187294 C-0.50864904 41.04964977 -0.57625231 36.76747457 -0.64819336 32.48535156 C-0.71751163 28.35518776 -0.78185116 24.22497401 -0.84269524 20.09467697 C-0.86682655 18.51654606 -0.89277148 16.93844184 -0.92053413 15.36037064 C-0.95902419 13.15516586 -0.99114551 10.94995549 -1.02172852 8.74462891 C-1.04171402 7.48776276 -1.06169952 6.23089661 -1.08229065 4.9359436 C-1 2 -1 2 0 0 Z ",
    fill: "#CFCFCF",
    transform: "translate(485,570)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C17.82 0 35.64 0 54 0 C54 0.33 54 0.66 54 1 C35.5974475 3.11176832 18.38098452 3.38272022 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#1F1F1F",
    transform: "translate(470,798)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C1.66 3 2.32 3 3 3 C4.00109515 6.31070838 4.10356134 9.30084769 4.0625 12.75 C4.05347656 13.73484375 4.04445313 14.7196875 4.03515625 15.734375 C4.02355469 16.48203125 4.01195312 17.2296875 4 18 C4.66 18 5.32 18 6 18 C6 28.56 6 39.12 6 50 C2.65169663 45.5355955 2.61615825 44.33477305 2.55859375 38.9609375 C2.54538589 38.28004059 2.53217804 37.59914368 2.51856995 36.89761353 C2.47779645 34.72336858 2.4560755 32.54953935 2.4375 30.375 C2.38039397 18.09524645 2.38039397 18.09524645 0.42211914 6.00244141 C0 4 0 4 0 0 Z ",
    fill: "#484949",
    transform: "translate(665,429)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.13142162 0.20299254 4.26244785 0.41594239 6.38671875 0.68359375 C9.00538683 1.00065222 11.62136611 1.22074608 14.25 1.4375 C17.81212255 1.7815056 20.76127234 2.38063617 24 4 C24 4.33 24 4.66 24 5 C11.79 5 -0.42 5 -13 5 C-13 4.34 -13 3.68 -13 3 C-9.90468901 1.4523445 -6.6333237 1.55590549 -3.21484375 1.28125 C-1.02929332 1.2334259 -1.02929332 1.2334259 0 0 Z ",
    fill: "#0D0D0D",
    transform: "translate(741,347)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.98 0.99 -1.98 0.99 -4 2 C-4 2.66 -4 3.32 -4 4 C-9.04109647 6.03412665 -13.52630971 7.56210478 -19 8 C-19.66 7.67 -20.32 7.34 -21 7 C-21.33 8.32 -21.66 9.64 -22 11 C-23.65 11.33 -25.3 11.66 -27 12 C-27.66 11.01 -28.32 10.02 -29 9 C-24.73506243 7.29731905 -20.46220749 5.61548555 -16.1875 3.9375 C-14.36508789 3.20950195 -14.36508789 3.20950195 -12.50585938 2.46679688 C-11.34248047 2.01240234 -10.17910156 1.55800781 -8.98046875 1.08984375 C-7.90692139 0.66566162 -6.83337402 0.24147949 -5.72729492 -0.19555664 C-3 -1 -3 -1 0 0 Z ",
    fill: "#3B3B3B",
    transform: "translate(418,228)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-18.68195416 1.89757408 -37.30248132 2.12672979 -56 2 C-56 1.67 -56 1.34 -56 1 C-50.45915522 0.11137395 -44.97839138 -0.30274721 -39.375 -0.5625 C-38.4890918 -0.6042334 -37.60318359 -0.6459668 -36.69042969 -0.68896484 C-24.38217838 -1.23784027 -12.27713738 -0.882567 0 0 Z ",
    fill: "#565655",
    transform: "translate(521,215)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.23 0.33 20.46 0.66 31 1 C30 10 30 10 28 13 C27.875 6.375 27.875 6.375 29 3 C27.89543457 2.970271 27.89543457 2.970271 26.76855469 2.93994141 C23.42867944 2.84462172 20.08942361 2.73497004 16.75 2.625 C15.59113281 2.5940625 14.43226563 2.563125 13.23828125 2.53125 C11.56572266 2.47324219 11.56572266 2.47324219 9.859375 2.4140625 C8.83295898 2.3826416 7.80654297 2.3512207 6.74902344 2.31884766 C4 2 4 2 0 0 Z ",
    fill: "#0D0D0D",
    transform: "translate(231,576)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.0580772 4.08327357 1.09362249 8.16644083 1.125 12.25 C1.14175781 13.40886719 1.15851563 14.56773437 1.17578125 15.76171875 C1.18222656 16.87675781 1.18867188 17.99179687 1.1953125 19.140625 C1.20578613 20.16704102 1.21625977 21.19345703 1.22705078 22.25097656 C0.99836111 25.01984288 0.4243299 26.64418792 -1 29 C-2.50974035 21.90961228 -3.28307925 15.24997422 -3 8 C-2.01 9.485 -2.01 9.485 -1 11 C-0.67 7.37 -0.34 3.74 0 0 Z ",
    fill: "#3E3F3E",
    transform: "translate(145,452)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.78230228 6.11075069 2.39831235 11.78527846 1 18 C0.01 18 -0.98 18 -2 18 C-2 21.3 -2 24.6 -2 28 C-2.33 28 -2.66 28 -3 28 C-3.11039334 19.59784035 -2.95458649 11.35263176 -2 3 C-1.34 3 -0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#474848",
    transform: "translate(146,432)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.1875 1.375 2.1875 1.375 5.0625 3.875 C7.88221942 6.31348184 10.55572534 7.42382092 14.1875 8.375 C13.8575 9.365 13.5275 10.355 13.1875 11.375 C9.58577553 10.025967 6.3580113 8.41783018 3.0625 6.4375 C2.21429688 5.93347656 1.36609375 5.42945313 0.4921875 4.91015625 C-1.56016184 3.54308288 -3.1562151 2.18825308 -4.8125 0.375 C-1.8125 -0.625 -1.8125 -0.625 0 0 Z ",
    fill: "#383939",
    transform: "translate(191.8125,557.625)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.67 9.57 0.34 19.14 0 29 C-0.33 29 -0.66 29 -1 29 C-2.30033449 24.01711825 -2.18381468 19.04904042 -2.1875 13.9375 C-2.19974609 13.03966797 -2.21199219 12.14183594 -2.22460938 11.21679688 C-2.22654297 10.34990234 -2.22847656 9.48300781 -2.23046875 8.58984375 C-2.23457764 7.80472412 -2.23868652 7.01960449 -2.24291992 6.21069336 C-1.97310575 3.75524885 -1.22414635 2.12777681 0 0 Z ",
    fill: "#232323",
    transform: "translate(258,590)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.04898437 0.77085937 1.09796875 1.54171875 1.1484375 2.3359375 C1.22320312 3.33882812 1.29796875 4.34171875 1.375 5.375 C1.44460938 6.37273438 1.51421875 7.37046875 1.5859375 8.3984375 C1.76363964 11.15508879 1.76363964 11.15508879 4 13 C4.1953125 15.6015625 4.1953125 15.6015625 4.125 18.625 C4.10695313 19.62789062 4.08890625 20.63078125 4.0703125 21.6640625 C4.03550781 22.82035156 4.03550781 22.82035156 4 24 C3.67 24 3.34 24 3 24 C2.67 25.65 2.34 27.3 2 29 C1.67 29 1.34 29 1 29 C-0.26693763 19.33960055 -0.08984092 9.72278418 0 0 Z ",
    fill: "#5C5D5D",
    transform: "translate(255,603)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.5055539 3.56173477 2.00346114 7.12449819 2.5 10.6875 C2.64308594 11.69490234 2.78617187 12.70230469 2.93359375 13.74023438 C3.06894531 14.71669922 3.20429688 15.69316406 3.34375 16.69921875 C3.46943359 17.59471436 3.59511719 18.49020996 3.72460938 19.4128418 C3.99616516 21.96397361 4.04847897 24.4366743 4 27 C2.25372522 24.38058783 1.61277612 22.96175123 1 20 C0.34 20.66 -0.32 21.32 -1 22 C-0.67 14.74 -0.34 7.48 0 0 Z ",
    fill: "#212120",
    transform: "translate(257,621)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -1.42578125 4.68359375 C-2.04839844 5.26238281 -2.67101562 5.84117187 -3.3125 6.4375 C-5.33570649 8.34808267 -6.92008524 9.8692304 -8.375 12.25 C-11.15388768 15.24264827 -15.14420613 15.93298786 -19 17 C-16.19351914 14.01811409 -13.37655901 11.47330301 -10.0625 9.0625 C-6.3279548 6.33422694 -3.18744426 3.34681647 0 0 Z ",
    fill: "#EFF0EF",
    transform: "translate(586,635)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.12470227 0.2023526 4.24903974 0.41356682 6.3671875 0.67578125 C9.09597156 1.01181846 11.82633982 1.29356118 14.5625 1.5625 C15.40941406 1.64628906 16.25632812 1.73007812 17.12890625 1.81640625 C17.74636719 1.87699219 18.36382813 1.93757813 19 2 C19 2.33 19 2.66 19 3 C9.1 3 -0.8 3 -11 3 C-11 2.67 -11 2.34 -11 2 C-10.28972656 1.93941406 -9.57945312 1.87882812 -8.84765625 1.81640625 C-7.46900391 1.69072266 -7.46900391 1.69072266 -6.0625 1.5625 C-5.14597656 1.48128906 -4.22945312 1.40007812 -3.28515625 1.31640625 C-1.03840268 1.23955024 -1.03840268 1.23955024 0 0 Z ",
    fill: "#6A6A69",
    transform: "translate(741,347)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.55429687 0.34933594 1.10859375 0.69867188 1.6796875 1.05859375 C2.76636719 1.74115234 2.76636719 1.74115234 3.875 2.4375 C4.95394531 3.11619141 4.95394531 3.11619141 6.0546875 3.80859375 C7.9777547 5.02461501 7.9777547 5.02461501 10 6 C11.125 8.0625 11.125 8.0625 12 10 C8.07316532 9.72603479 6.27231386 9.22390251 3.1875 6.6875 C1.12066942 4.148251 0.60769648 3.06461989 0 0 Z ",
    fill: "#3C3C3B",
    transform: "translate(659,267)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.38530129 3.42717768 -2.67477227 4.7293493 -6 6.3125 C-6.70125 6.65925781 -7.4025 7.00601563 -8.125 7.36328125 C-9.053125 7.67845703 -9.053125 7.67845703 -10 8 C-10.66 7.67 -11.32 7.34 -12 7 C-11.67 6.34 -11.34 5.68 -11 5 C-10.34 5 -9.68 5 -9 5 C-8.67 4.01 -8.34 3.02 -8 2 C-5.01540871 0.04457812 -3.73585209 0 0 0 Z ",
    fill: "#383939",
    transform: "translate(801,562)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.78230428 1.85486952 -4.84363607 2.72462112 -8 3.6875 C-8.86625 3.95949219 -9.7325 4.23148438 -10.625 4.51171875 C-13 5 -13 5 -16 4 C-15.34 4 -14.68 4 -14 4 C-14 3.34 -14 2.68 -14 2 C-8.76579213 -1.27137992 -5.83394389 -1.10643764 0 0 Z ",
    fill: "#404141",
    transform: "translate(784,572)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.85584773 1.90389849 -4.9311762 2.69462177 -8.1875 3.625 C-9.08855469 3.88539063 -9.98960937 4.14578125 -10.91796875 4.4140625 C-11.94857422 4.70410156 -11.94857422 4.70410156 -13 5 C-12.6328125 3.08203125 -12.6328125 3.08203125 -12 1 C-7.89362363 -1.53629129 -4.59671159 -0.901316 0 0 Z ",
    fill: "#3F3F3E",
    transform: "translate(611,779)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.93558599 0.67220351 -3.87354372 1.33758077 -5.8125 2 C-6.89144531 2.37125 -7.97039062 2.7425 -9.08203125 3.125 C-12 4 -12 4 -15 4 C-15 4.66 -15 5.32 -15 6 C-18.28696233 6.79953138 -19.71023192 7.09658936 -23 6 C-20.95900065 5.2066145 -18.9171691 4.4153697 -16.875 3.625 C-15.73804688 3.18414062 -14.60109375 2.74328125 -13.4296875 2.2890625 C-12.29789062 1.86367187 -11.16609375 1.43828125 -10 1 C-8.95070313 0.59523437 -7.90140625 0.19046875 -6.8203125 -0.2265625 C-3.97985536 -1.00552443 -2.70449088 -1.0401888 0 0 Z ",
    fill: "#8B8A89",
    transform: "translate(430,254)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1 2 -1 2 -2.9375 2.6875 C-5 3 -5 3 -7 2 C-7.33 3.32 -7.66 4.64 -8 6 C-9.65 6.33 -11.3 6.66 -13 7 C-13.66 6.01 -14.32 5.02 -15 4 C-13.06767179 3.13419713 -11.12892806 2.28270059 -9.1875 1.4375 C-8.10855469 0.96183594 -7.02960938 0.48617187 -5.91796875 -0.00390625 C-3 -1 -3 -1 0 0 Z ",
    fill: "#434342",
    transform: "translate(404,233)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.20452542 2.29855607 -2.41323296 3.58888195 -4.625 4.875 C-5.24246094 5.23980469 -5.85992188 5.60460937 -6.49609375 5.98046875 C-10.24106836 8.14861194 -13.81827217 9.77764879 -18 11 C-17 8 -17 8 -14.453125 6.71875 C-13.39609375 6.3165625 -12.3390625 5.914375 -11.25 5.5 C-8.03878657 4.26613474 -5.15993767 3.09939629 -2.234375 1.28125 C-1.12835937 0.64703125 -1.12835937 0.64703125 0 0 Z ",
    fill: "#8B8B8A",
    transform: "translate(633,735)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.93 0.33 13.86 0.66 21 1 C21 1.33 21 1.66 21 2 C16.05 2 11.1 2 6 2 C6 2.66 6 3.32 6 4 C5.01 4.33 4.02 4.66 3 5 C3 4.34 3 3.68 3 3 C2.01 2.01 1.02 1.02 0 0 Z ",
    fill: "#3C3B3B",
    transform: "translate(738,577)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.98822811 1.77254583 6.82004528 3.12452494 9 7 C9 7.99 9 8.98 9 10 C5.17647894 8.4422692 2.70794407 6.08404742 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#3D3C3C",
    transform: "translate(176,546)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.71034824 2.37562854 -0.62689293 3.70766393 -2 5 C-2.66 5 -3.32 5 -4 5 C-5.80693756 6.78612311 -5.80693756 6.78612311 -7.625 9 C-8.57246094 10.11375 -8.57246094 10.11375 -9.5390625 11.25 C-10.02117187 11.8275 -10.50328125 12.405 -11 13 C-11.66 12.67 -12.32 12.34 -13 12 C-12.566875 11.60167969 -12.13375 11.20335937 -11.6875 10.79296875 C-11.130625 10.26316406 -10.57375 9.73335938 -10 9.1875 C-9.443125 8.66542969 -8.88625 8.14335937 -8.3125 7.60546875 C-6.683535 5.95851033 -6.683535 5.95851033 -7 3 C-5.5459375 2.5359375 -5.5459375 2.5359375 -4.0625 2.0625 C-1.15934208 1.30476658 -1.15934208 1.30476658 0 0 Z ",
    fill: "#3E3F3E",
    transform: "translate(332,275)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.99 0.495 -0.99 0.495 -2 1 C-2 1.66 -2 2.32 -2 3 C-6.455 3.495 -6.455 3.495 -11 4 C-11.66 3.01 -12.32 2.02 -13 1 C-11.58622218 0.63447197 -10.16879424 0.28304505 -8.75 -0.0625 C-7.96109375 -0.25972656 -7.1721875 -0.45695313 -6.359375 -0.66015625 C-3.89605178 -1.01497267 -2.34395868 -0.76877544 0 0 Z ",
    fill: "#484747",
    transform: "translate(450,220)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.7242265 6.2049038 -0.10640794 10.10160999 -4 15 C-4.33 14.34 -4.66 13.68 -5 13 C-4.34938905 11.32700041 -3.67966676 9.66140763 -3 8 C-2.62406934 6.0075675 -2.28020455 4.0081326 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#2A2A2A",
    transform: "translate(733,656)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C-1.625 8.875 -1.625 8.875 -5 10 C-5.33 9.34 -5.66 8.68 -6 8 C-4.02 5.36 -2.04 2.72 0 0 Z ",
    fill: "#393939",
    transform: "translate(294,311)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3.04241723 2.33294775 3.04092937 4.66702567 3 7 C2.67 7.33 2.34 7.66 2 8 C1.60545777 9.84599688 1.25823134 11.70225822 0.9375 13.5625 C0.76089844 14.57441406 0.58429688 15.58632813 0.40234375 16.62890625 C0.26957031 17.41136719 0.13679688 18.19382812 0 19 C-1.35862973 15.09519751 -0.89469712 11.2898224 -0.5625 7.25 C-0.48418945 6.20392578 -0.48418945 6.20392578 -0.40429688 5.13671875 C-0.27525928 3.42403797 -0.13840386 1.71194934 0 0 Z ",
    fill: "#3C3C3C",
    transform: "translate(434,480)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.11458693 1.43836751 -0.24209116 2.87570966 -0.375 4.3125 C-0.44460938 5.11300781 -0.51421875 5.91351562 -0.5859375 6.73828125 C-1 9 -1 9 -3 12 C-3.125 5.375 -3.125 5.375 -2 2 C-5.3 2 -8.6 2 -12 2 C-12 1.67 -12 1.34 -12 1 C-10.37512529 0.83211627 -8.75009558 0.66573213 -7.125 0.5 C-6.22007812 0.4071875 -5.31515625 0.314375 -4.3828125 0.21875 C-2 0 -2 0 0 0 Z ",
    fill: "#1A1919",
    transform: "translate(262,577)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.03644647 9.41002278 0.03644647 9.41002278 -1 14 C-1.99 13.34 -2.98 12.68 -4 12 C-3.67 9.03 -3.34 6.06 -3 3 C-2.01 3.33 -1.02 3.66 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#494A49",
    transform: "translate(854,482)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.640625 1.76953125 0.640625 1.76953125 1 4 C0.109375 5.88671875 0.109375 5.88671875 -1.25 7.6875 C-1.68828125 8.28949219 -2.1265625 8.89148438 -2.578125 9.51171875 C-4 11 -4 11 -7 12 C-5.80065338 8.91596583 -4.52022974 5.93911083 -3 3 C-2.67 2.34 -2.34 1.68 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#393939",
    transform: "translate(283,326)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.06998019 0.65419099 9.41990777 2.8546409 14 5 C14 5.33 14 5.66 14 6 C8.72250715 5.46148032 4.74354436 4.22656164 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#2B2B2B",
    transform: "translate(373,773)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.87132028 0.57352893 6.08172796 2.48704352 9 5 C8.34 6.32 7.68 7.64 7 9 C5.83037314 7.69013727 4.66437056 6.3770374 3.5 5.0625 C2.8503125 4.33160156 2.200625 3.60070312 1.53125 2.84765625 C0 1 0 1 0 0 Z ",
    fill: "#3D3D3C",
    transform: "translate(166,537)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.55664559 2.22317008 3.3936615 3.68845894 4 7 C4.06624507 8.74886981 4.08552595 10.50002748 4.0625 12.25 C4.05347656 13.14203125 4.04445313 14.0340625 4.03515625 14.953125 C4.02355469 15.62859375 4.01195312 16.3040625 4 17 C3.67 17 3.34 17 3 17 C2.49453964 14.91798472 1.99583165 12.83432933 1.5 10.75 C1.2215625 9.58984375 0.943125 8.4296875 0.65625 7.234375 C0 4 0 4 0 0 Z ",
    fill: "#212020",
    transform: "translate(850,429)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C2.475 1.495 2.475 1.495 5 2 C5 2.33 5 2.66 5 3 C-1.74233419 3.12910853 -8.30386804 2.797837 -15 2 C-15 1.67 -15 1.34 -15 1 C-13.43784452 0.83013455 -11.8752548 0.66426036 -10.3125 0.5 C-9.44238281 0.4071875 -8.57226562 0.314375 -7.67578125 0.21875 C-5.10276661 0.00840136 -2.58015636 -0.03719144 0 0 Z ",
    fill: "#5D5D5C",
    transform: "translate(473,797)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 4.28535967 -2.2516278 5.84942699 -5 9 C-5.33 9.66 -5.66 10.32 -6 11 C-6.66 11 -7.32 11 -8 11 C-7.91433603 8.087425 -7.42089045 6.43201976 -5.375 4.33203125 C-3.61608625 2.83908228 -1.83686981 1.39563738 0 0 Z ",
    fill: "#292A29",
    transform: "translate(175,383)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.75453595 4.73639216 -0.63404953 5.18756513 -4 7 C-4 6.34 -4 5.68 -4 5 C-5.32 4.67 -6.64 4.34 -8 4 C-6.71349294 3.30289269 -5.42059335 2.61757124 -4.125 1.9375 C-3.40570313 1.55464844 -2.68640625 1.17179688 -1.9453125 0.77734375 C-1.30335938 0.52082031 -0.66140625 0.26429688 0 0 Z ",
    fill: "#3E3E3E",
    transform: "translate(387,238)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.99 1.485 -0.99 1.485 -2 3 C-4.3828125 3.29296875 -4.3828125 3.29296875 -7.125 3.1875 C-8.03507812 3.16042969 -8.94515625 3.13335937 -9.8828125 3.10546875 C-10.58148438 3.07066406 -11.28015625 3.03585937 -12 3 C-11.67 2.01 -11.34 1.02 -11 0 C-9.54263913 -0.19491452 -8.08405407 -0.38069358 -6.625 -0.5625 C-5.81289063 -0.66691406 -5.00078125 -0.77132813 -4.1640625 -0.87890625 C-2 -1 -2 -1 0 0 Z ",
    fill: "#C8C8C7",
    transform: "translate(506,417)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3 1.66 3 2.32 3 3 C3.969375 3.12375 4.93875 3.2475 5.9375 3.375 C7.4534375 3.684375 7.4534375 3.684375 9 4 C9.33 4.66 9.66 5.32 10 6 C7.8125 6.75 7.8125 6.75 5 7 C2.1875 5.25 2.1875 5.25 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#404040",
    transform: "translate(350,759)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C0.36 2.98 -2.28 4.96 -5 7 C-5.66 6.67 -6.32 6.34 -7 6 C-7 5.01 -7 4.02 -7 3 C-6.21625 2.690625 -5.4325 2.38125 -4.625 2.0625 C-2.07669872 1.07124962 -2.07669872 1.07124962 0 0 Z ",
    fill: "#3C3D3D",
    transform: "translate(662,749)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.58912412 -0.66436554 4.10857029 -3 6.6875 C-3.556875 7.31011719 -4.11375 7.93273437 -4.6875 8.57421875 C-5.120625 9.04472656 -5.55375 9.51523437 -6 10 C-6.99 9.34 -7.98 8.68 -9 8 C-8.25 6.0625 -8.25 6.0625 -7 4 C-5.0625 3.4375 -5.0625 3.4375 -3 3 C-1.26973898 1.52109931 -1.26973898 1.52109931 0 0 Z ",
    fill: "#3A3B3A",
    transform: "translate(612,694)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.61500768 2.36595933 4.38999603 4.86049226 6 8 C5.67 8.66 5.34 9.32 5 10 C3.0625 9.5 3.0625 9.5 1 8 C0.31209578 5.30341548 0.18053536 2.7982981 0 0 Z ",
    fill: "#3A3A38",
    transform: "translate(720,334)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C1.90220176 2.15193623 0.79650554 3.29634937 -0.3125 4.4375 C-0.92738281 5.07558594 -1.54226563 5.71367187 -2.17578125 6.37109375 C-4 8 -4 8 -7 9 C-5.44499019 5.18315774 -2.96404505 2.80804268 0 0 Z ",
    fill: "#242423",
    transform: "translate(323,280)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.625 0.1875 3.625 0.1875 6.625 2.1875 C3.655 2.8475 0.685 3.5075 -2.375 4.1875 C-3.035 3.1975 -3.695 2.2075 -4.375 1.1875 C-3.375 0.1875 -3.375 0.1875 0 0 Z ",
    fill: "#414140",
    transform: "translate(587.375,783.8125)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98362069 2.91708924 1.9876191 4.12380904 1.625 7.75 C1.41875 8.8225 1.2125 9.895 1 11 C0.34 11 -0.32 11 -1 11 C-1.33 8.69 -1.66 6.38 -2 4 C-1.34 4 -0.68 4 0 4 C0 2.68 0 1.36 0 0 Z M0 5 C1 7 1 7 1 7 Z ",
    fill: "#6D6C6B",
    transform: "translate(258,641)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.96404505 2.80804268 5.44499019 5.18315774 7 9 C6.01 9.33 5.02 9.66 4 10 C0 4.5 0 4.5 0 0 Z ",
    fill: "#393939",
    transform: "translate(696,301)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.50298434 2.93828597 3.46930939 5.17902761 4 9 C3.67 8.34 3.34 7.68 3 7 C1.02111039 6.27306096 -0.97954558 5.60183749 -3 5 C-2.01 3.35 -1.02 1.7 0 0 Z ",
    fill: "#3A3B3A",
    transform: "translate(270,674)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.5654594 2.5654594 2.54046087 4.47686668 3 8 C2.01 8.66 1.02 9.32 0 10 C-0.66 7.03 -1.32 4.06 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#434342",
    transform: "translate(263,652)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.63 1 7.26 1 11 C0.01 11 -0.98 11 -2 11 C-2.25 3.375 -2.25 3.375 0 0 Z ",
    fill: "#6A6A6A",
    transform: "translate(273,473)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3.33 0.66 3.66 1.32 4 2 C3.3125 4.0625 3.3125 4.0625 2 6 C-0.125 6.75 -0.125 6.75 -2 7 C-1.34 4.69 -0.68 2.38 0 0 Z ",
    fill: "#3A3B3A",
    transform: "translate(153,412)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C5.67 0.66 5.34 1.32 5 2 C5.33 2.33 5.66 2.66 6 3 C6 3.99 6 4.98 6 6 C5.34 6 4.68 6 4 6 C4 5.34 4 4.68 4 4 C2.68 3.34 1.36 2.68 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#414040",
    transform: "translate(682,288)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0.33 3.3 0.66 5 1 C5 1.66 5 2.32 5 3 C5.99 3.99 6.98 4.98 8 6 C5.03 5.01 2.06 4.02 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#3A3A3A",
    transform: "translate(599,234)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.25 -0.25 2.25 -0.25 5 0 C7.3125 2 7.3125 2 9 4 C7.3125 4.8125 7.3125 4.8125 5 5 C2.25 2.5625 2.25 2.5625 0 0 Z ",
    fill: "#3E3E3E",
    transform: "translate(326,745)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.73120489 -1.18031476 5.78055689 -3 9 C-3.99 9.495 -3.99 9.495 -5 10 C-5.3125 7.8125 -5.3125 7.8125 -5 5 C-2.5 2.1875 -2.5 2.1875 0 0 Z ",
    fill: "#3C3C3C",
    transform: "translate(693,720)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.18234854 3.69483919 1.2804701 7.14353614 1 11 C-0.515625 12.71484375 -0.515625 12.71484375 -2 14 C-1.85923685 12.0412957 -1.7122324 10.08303907 -1.5625 8.125 C-1.48128906 7.03445313 -1.40007812 5.94390625 -1.31640625 4.8203125 C-1 2 -1 2 0 0 Z ",
    fill: "#181817",
    transform: "translate(333,588)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.125 -0.1875 3.125 -0.1875 6 0 C4.515 1.98 4.515 1.98 3 4 C1.35 3.67 -0.3 3.34 -2 3 C-1.34 2.01 -0.68 1.02 0 0 Z ",
    fill: "#3A3A3A",
    transform: "translate(341,265)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 2.83967231 -0.40267181 5.23735711 -1 8 C-1.99 8 -2.98 8 -4 8 C-4 4.09161134 -2.49432124 2.88405893 0 0 Z ",
    fill: "#3D3D3C",
    transform: "translate(708,702)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.04131267 1.34710422 4.90288434 3.38428334 7 7 C7 7.99 7 8.98 7 10 C3.60582235 6.87378374 1.3937282 4.43458973 0 0 Z ",
    fill: "#E0E0E0",
    transform: "translate(391,505)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.2542015 2.83430453 4.5206753 4.68607774 5 9 C2 8 2 8 0.25 5.0625 C-0.1625 4.051875 -0.575 3.04125 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#40403F",
    transform: "translate(841,406)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.25 3.5625 -0.25 3.5625 -3 6 C-4.32 5.67 -5.64 5.34 -7 5 C-4.69 3.35 -2.38 1.7 0 0 Z ",
    fill: "#3B3B3B",
    transform: "translate(196,364)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.7425 0.0825 1.485 0.165 2.25 0.25 C0.72058649 3.30882701 -1.69219546 3.93951234 -4.75 5.25 C-5.41 4.92 -6.07 4.59 -6.75 4.25 C-3.42692308 0.31153846 -3.42692308 0.31153846 0 0 Z ",
    fill: "#2A2B2B",
    transform: "translate(203.75,360.75)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-5.0546875 2.1953125 -5.0546875 2.1953125 -7 2 C-7.66 1.34 -8.32 0.68 -9 0 C-5.88173308 -1.55913346 -3.32926126 -0.66585225 0 0 Z ",
    fill: "#404040",
    transform: "translate(793,359)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C7.66 2.66 8.32 3.32 9 4 C6.69 3.67 4.38 3.34 2 3 C2 2.34 2 1.68 2 1 C1.34 0.67 0.68 0.34 0 0 Z ",
    fill: "#515150",
    transform: "translate(613,240)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 3 3 C0.6875 4.125 0.6875 4.125 -2 5 C-2.99 4.34 -3.98 3.68 -5 3 C-2.625 1.4375 -2.625 1.4375 0 0 Z ",
    fill: "#40403F",
    transform: "translate(635,764)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.08888522 2.05925681 -3.70935927 2.2390374 -7.1875 2.125 C-9.0746875 2.063125 -9.0746875 2.063125 -11 2 C-7.00042393 -0.06874624 -4.43559483 -1.37656391 0 0 Z ",
    fill: "#1F1F1E",
    transform: "translate(580,789)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2.40729228 3.32156597 2.74438677 5.6568787 3 8 C1.35 6.35 -0.3 4.7 -2 3 C-1.34 2.67 -0.68 2.34 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#40403F",
    transform: "translate(290,705)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.598125 0.350625 1.19625 0.70125 1.8125 1.0625 C1.4825 2.0525 1.1525 3.0425 0.8125 4.0625 C-1.65550047 2.91076645 -3.23533565 2.01466435 -5.1875 0.0625 C-2.1875 -0.9375 -2.1875 -0.9375 0 0 Z ",
    fill: "#424242",
    transform: "translate(192.1875,557.9375)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C1.35 2.65 -0.3 4.3 -2 6 C-2.33 4.68 -2.66 3.36 -3 2 C-2.01 1.34 -1.02 0.68 0 0 Z ",
    fill: "#3E3E3E",
    transform: "translate(829,536)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C1.66 3 2.32 3 3 3 C3.33 4.32 3.66 5.64 4 7 C3.01 7.66 2.02 8.32 1 9 C0.67 6.03 0.34 3.06 0 0 Z ",
    fill: "#1B1C1C",
    transform: "translate(665,429)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.74627478 2.61941217 2.38722388 4.03824877 3 7 C2.34 7 1.68 7 1 7 C0.67 7.66 0.34 8.32 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#616060",
    transform: "translate(264,667)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.99 1.98 1.98 3 3 C2.67 3.99 2.34 4.98 2 6 C1.34 6 0.68 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#5F5F5F",
    transform: "translate(272,685)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1.99 1.02 2.98 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#646363",
    transform: "translate(346,256)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#5C5D5E",
    transform: "translate(743,622)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1.99 1.02 2.98 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#6A6968",
    transform: "translate(192,360)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 1.32 1.34 2.64 1 4 C0.67 2.68 0.34 1.36 0 0 Z ",
    fill: "#5C5B59",
    transform: "translate(272,337)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C-0.33 2.66 -0.66 3.32 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#60605F",
    transform: "translate(275,690)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.485 0.99 1.485 0.99 3 2 C2.01 2.495 2.01 2.495 1 3 C0.34 2.34 -0.32 1.68 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#646263",
    transform: "translate(193,564)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C4.01 0.66 3.02 1.32 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#686767",
    transform: "translate(196,360)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.34 1 1.68 1 1 1 C0.67 1.66 0.34 2.32 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#5F5D5D",
    transform: "translate(384,781)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C2.68 1.33 1.36 1.66 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#5F5F5E",
    transform: "translate(753,580)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.01 1.495 3.01 1.495 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#5E5D5E",
    transform: "translate(796,360)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#5F5E5F",
    transform: "translate(296,304)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 0.66 3 1.32 3 2 C2.01 1.67 1.02 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#626262",
    transform: "translate(661,264)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.01 1.495 3.01 1.495 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#616161",
    transform: "translate(603,233)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.01 1.67 -0.98 1.34 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#5E5F5C",
    transform: "translate(338,756)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 1.485 0.99 1.485 2 3 C1.34 3 0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#616060",
    transform: "translate(280,701)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#5F5E5D",
    transform: "translate(280,698)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.34 1.66 0.68 2.32 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#656565",
    transform: "translate(160,533)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#656564",
    transform: "translate(156,525)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 0.66 2.34 1.32 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#666666",
    transform: "translate(152,520)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#666665",
    transform: "translate(837,392)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#666566",
    transform: "translate(176,376)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.01 1.67 -0.98 1.34 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#666667",
    transform: "translate(210,354)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#605F5E",
    transform: "translate(281,323)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#5C5C5B",
    transform: "translate(694,296)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#606060",
    transform: "translate(338,264)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#61615F",
    transform: "translate(446,798)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#5F5D5C",
    transform: "translate(411,790)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#5F605E",
    transform: "translate(277,693)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F6061",
    transform: "translate(0,0)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#61605E",
    transform: "translate(236,580)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#5F5E5D",
    transform: "translate(232,579)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676766",
    transform: "translate(0,0)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#686868",
    transform: "translate(0,0)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676767",
    transform: "translate(0,0)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#656666",
    transform: "translate(851,424)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#686867",
    transform: "translate(0,0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#676767",
    transform: "translate(160,395)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666665",
    transform: "translate(0,0)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#646264",
    transform: "translate(186,368)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#615F5E",
    transform: "translate(777,352)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#656666",
    transform: "translate(216,352)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#595957",
    transform: "translate(736,347)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#636362",
    transform: "translate(759,346)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#5B5958",
    transform: "translate(724,338)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#5D5C5B",
    transform: "translate(703,305)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#615F5E",
    transform: "translate(621,240)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#656462",
    transform: "translate(408,227)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#616060",
    transform: "translate(419,224)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#646462",
    transform: "translate(452,216)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5E5D5D",
    transform: "translate(456,799)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#626060",
    transform: "translate(452,799)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#605F5D",
    transform: "translate(444,799)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#605E5E",
    transform: "translate(0,0)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#605F5E",
    transform: "translate(547,798)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#615F5F",
    transform: "translate(0,0)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#605E5E",
    transform: "translate(407,789)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5E5D5C",
    transform: "translate(389,783)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5D5D5B",
    transform: "translate(387,782)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61615E",
    transform: "translate(0,0)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5F5E",
    transform: "translate(0,0)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5E5C",
    transform: "translate(0,0)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5E595A",
    transform: "translate(642,765)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D5D5C",
    transform: "translate(0,0)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5F5E",
    transform: "translate(0,0)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#605F5E",
    transform: "translate(686,735)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#646262",
    transform: "translate(304,731)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#605F5E",
    transform: "translate(0,0)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5D5E",
    transform: "translate(0,0)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#636263",
    transform: "translate(264,679)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#606160",
    transform: "translate(0,0)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5F5E",
    transform: "translate(0,0)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626160",
    transform: "translate(0,0)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A5B5C",
    transform: "translate(0,0)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5D5C",
    transform: "translate(0,0)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#605F5D",
    transform: "translate(0,0)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5E5C5D",
    transform: "translate(749,580)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5F605D",
    transform: "translate(242,580)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#606060",
    transform: "translate(763,579)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646463",
    transform: "translate(0,0)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#636364",
    transform: "translate(192,567)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636264",
    transform: "translate(0,0)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#6C6A6C",
    transform: "translate(147,510)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B6A69",
    transform: "translate(0,0)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#686868",
    transform: "translate(854,499)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696867",
    transform: "translate(0,0)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676867",
    transform: "translate(0,0)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656665",
    transform: "translate(0,0)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696868",
    transform: "translate(0,0)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676666",
    transform: "translate(0,0)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646362",
    transform: "translate(0,0)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#69696A",
    transform: "translate(152,405)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656466",
    transform: "translate(0,0)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#626263",
    transform: "translate(827,384)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#616061",
    transform: "translate(788,356)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5D5D5C",
    transform: "translate(780,353)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626260",
    transform: "translate(0,0)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#616060",
    transform: "translate(251,346)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A5A59",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5B5B59",
    transform: "translate(701,304)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5F5E",
    transform: "translate(0,0)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#605E5E",
    transform: "translate(678,281)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636362",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#616161",
    transform: "translate(0,0)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#616060",
    transform: "translate(646,256)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#636262",
    transform: "translate(636,248)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#605F5D",
    transform: "translate(633,248)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666563",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#61615F",
    transform: "translate(397,232)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656666",
    transform: "translate(0,0)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#646364",
    transform: "translate(443,216)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#656462",
    transform: "translate(475,213)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A7A7",
    transform: "translate(0,0)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#767576",
    transform: "translate(0,0)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8E8E",
    transform: "translate(0,0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#717272",
    transform: "translate(0,0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5D5C",
    transform: "translate(0,0)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#585658",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636161",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#625F5F",
    transform: "translate(0,0)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D5B5A",
    transform: "translate(0,0)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#615D5F",
    transform: "translate(0,0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#605F5F",
    transform: "translate(0,0)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626061",
    transform: "translate(0,0)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A5B5A",
    transform: "translate(0,0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#606061",
    transform: "translate(0,0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5B5B5B",
    transform: "translate(0,0)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62625F",
    transform: "translate(0,0)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61605F",
    transform: "translate(0,0)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636262",
    transform: "translate(0,0)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#606160",
    transform: "translate(0,0)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626360",
    transform: "translate(0,0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#605F5D",
    transform: "translate(0,0)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A5B5A",
    transform: "translate(0,0)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#616060",
    transform: "translate(0,0)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5F5F",
    transform: "translate(0,0)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5F5E",
    transform: "translate(0,0)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5B5858",
    transform: "translate(0,0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D5D5E",
    transform: "translate(0,0)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626260",
    transform: "translate(0,0)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61605E",
    transform: "translate(0,0)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61625D",
    transform: "translate(0,0)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#605D5F",
    transform: "translate(0,0)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D5D5B",
    transform: "translate(0,0)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5F5E",
    transform: "translate(0,0)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60605F",
    transform: "translate(0,0)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5D5D",
    transform: "translate(0,0)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E605F",
    transform: "translate(0,0)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5D5E",
    transform: "translate(0,0)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#616060",
    transform: "translate(0,0)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C5C5D",
    transform: "translate(0,0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61615F",
    transform: "translate(0,0)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D5E5D",
    transform: "translate(0,0)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61615E",
    transform: "translate(0,0)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#606260",
    transform: "translate(0,0)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D5D5E",
    transform: "translate(0,0)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626463",
    transform: "translate(0,0)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5F5D",
    transform: "translate(0,0)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C5D5D",
    transform: "translate(0,0)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626060",
    transform: "translate(0,0)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636160",
    transform: "translate(0,0)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#625F5E",
    transform: "translate(0,0)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626260",
    transform: "translate(0,0)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636360",
    transform: "translate(0,0)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60615E",
    transform: "translate(0,0)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636461",
    transform: "translate(0,0)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F6060",
    transform: "translate(0,0)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#606160",
    transform: "translate(0,0)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5B5A59",
    transform: "translate(0,0)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#625C5D",
    transform: "translate(0,0)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#606060",
    transform: "translate(0,0)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636461",
    transform: "translate(0,0)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636464",
    transform: "translate(0,0)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61615E",
    transform: "translate(0,0)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5F5E",
    transform: "translate(0,0)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A5859",
    transform: "translate(0,0)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626164",
    transform: "translate(0,0)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#58595A",
    transform: "translate(0,0)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#606161",
    transform: "translate(0,0)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F6160",
    transform: "translate(0,0)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#606160",
    transform: "translate(0,0)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636365",
    transform: "translate(0,0)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#606060",
    transform: "translate(0,0)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5F5F",
    transform: "translate(0,0)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C5F5D",
    transform: "translate(0,0)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5F5D",
    transform: "translate(0,0)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#595B5A",
    transform: "translate(0,0)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5F5E",
    transform: "translate(0,0)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#605D5D",
    transform: "translate(0,0)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#625F5D",
    transform: "translate(0,0)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#616161",
    transform: "translate(0,0)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#605F5C",
    transform: "translate(0,0)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5C5D",
    transform: "translate(0,0)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#615F5F",
    transform: "translate(0,0)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#616060",
    transform: "translate(0,0)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636062",
    transform: "translate(0,0)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5C5D",
    transform: "translate(0,0)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5E5D",
    transform: "translate(0,0)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#605F5F",
    transform: "translate(0,0)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C5C5A",
    transform: "translate(0,0)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5E5D",
    transform: "translate(0,0)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656364",
    transform: "translate(0,0)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636261",
    transform: "translate(0,0)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#616162",
    transform: "translate(0,0)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676465",
    transform: "translate(0,0)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636262",
    transform: "translate(0,0)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636365",
    transform: "translate(0,0)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646263",
    transform: "translate(0,0)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5D5D",
    transform: "translate(0,0)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626361",
    transform: "translate(0,0)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646261",
    transform: "translate(0,0)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#686665",
    transform: "translate(0,0)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646462",
    transform: "translate(0,0)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F6160",
    transform: "translate(0,0)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60605F",
    transform: "translate(0,0)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666767",
    transform: "translate(0,0)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666465",
    transform: "translate(0,0)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D5C5D",
    transform: "translate(0,0)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#606160",
    transform: "translate(0,0)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656564",
    transform: "translate(0,0)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5D5F",
    transform: "translate(0,0)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656665",
    transform: "translate(0,0)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666566",
    transform: "translate(0,0)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#686768",
    transform: "translate(0,0)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636362",
    transform: "translate(0,0)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#605F61",
    transform: "translate(0,0)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#606261",
    transform: "translate(0,0)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626361",
    transform: "translate(0,0)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666363",
    transform: "translate(0,0)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646562",
    transform: "translate(0,0)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A6A6A",
    transform: "translate(0,0)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#67696A",
    transform: "translate(0,0)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666467",
    transform: "translate(0,0)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696868",
    transform: "translate(0,0)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B6A69",
    transform: "translate(0,0)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C686B",
    transform: "translate(0,0)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656363",
    transform: "translate(0,0)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D6B6B",
    transform: "translate(0,0)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656665",
    transform: "translate(0,0)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646665",
    transform: "translate(0,0)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696A6A",
    transform: "translate(0,0)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696869",
    transform: "translate(0,0)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696766",
    transform: "translate(0,0)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#686767",
    transform: "translate(0,0)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6E6E6D",
    transform: "translate(0,0)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#686867",
    transform: "translate(0,0)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A6968",
    transform: "translate(0,0)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666666",
    transform: "translate(0,0)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666665",
    transform: "translate(0,0)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656463",
    transform: "translate(0,0)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#606061",
    transform: "translate(0,0)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656562",
    transform: "translate(0,0)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636262",
    transform: "translate(0,0)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626161",
    transform: "translate(0,0)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626364",
    transform: "translate(0,0)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636463",
    transform: "translate(0,0)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5E5F",
    transform: "translate(0,0)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656563",
    transform: "translate(0,0)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A6966",
    transform: "translate(0,0)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666464",
    transform: "translate(0,0)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646466",
    transform: "translate(0,0)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#615F5F",
    transform: "translate(0,0)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#615F60",
    transform: "translate(0,0)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666662",
    transform: "translate(0,0)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656364",
    transform: "translate(0,0)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676767",
    transform: "translate(0,0)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656565",
    transform: "translate(0,0)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656566",
    transform: "translate(0,0)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A676B",
    transform: "translate(0,0)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636364",
    transform: "translate(0,0)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676768",
    transform: "translate(0,0)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656663",
    transform: "translate(0,0)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646463",
    transform: "translate(0,0)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#686567",
    transform: "translate(0,0)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAFAF",
    transform: "translate(0,0)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969798",
    transform: "translate(0,0)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676665",
    transform: "translate(0,0)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61605F",
    transform: "translate(0,0)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626360",
    transform: "translate(0,0)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A5B59",
    transform: "translate(0,0)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5B5A",
    transform: "translate(0,0)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5E5D",
    transform: "translate(0,0)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626260",
    transform: "translate(0,0)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#686866",
    transform: "translate(0,0)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636362",
    transform: "translate(0,0)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636061",
    transform: "translate(0,0)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#625F5E",
    transform: "translate(0,0)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C5E5B",
    transform: "translate(0,0)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61615F",
    transform: "translate(0,0)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5E5B",
    transform: "translate(0,0)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5F5E",
    transform: "translate(0,0)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5C5A",
    transform: "translate(0,0)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C5A5A",
    transform: "translate(0,0)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5C5C",
    transform: "translate(0,0)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5E5C",
    transform: "translate(0,0)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C5B58",
    transform: "translate(0,0)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#615D60",
    transform: "translate(0,0)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61605E",
    transform: "translate(0,0)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D5C5B",
    transform: "translate(0,0)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5B5D5D",
    transform: "translate(0,0)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5F5E",
    transform: "translate(0,0)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5F5F",
    transform: "translate(0,0)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C5D5E",
    transform: "translate(0,0)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5B5C5C",
    transform: "translate(0,0)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#605F5F",
    transform: "translate(0,0)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636263",
    transform: "translate(0,0)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626363",
    transform: "translate(0,0)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5C5E",
    transform: "translate(0,0)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#615F5F",
    transform: "translate(0,0)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636161",
    transform: "translate(0,0)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636161",
    transform: "translate(0,0)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646362",
    transform: "translate(0,0)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656261",
    transform: "translate(0,0)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646463",
    transform: "translate(0,0)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636260",
    transform: "translate(0,0)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636363",
    transform: "translate(0,0)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#616161",
    transform: "translate(0,0)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#635F61",
    transform: "translate(0,0)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626160",
    transform: "translate(0,0)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646060",
    transform: "translate(0,0)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5F5F",
    transform: "translate(0,0)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F615D",
    transform: "translate(0,0)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646463",
    transform: "translate(0,0)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#616060",
    transform: "translate(0,0)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#616064",
    transform: "translate(0,0)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5D5E",
    transform: "translate(0,0)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646764",
    transform: "translate(0,0)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646563",
    transform: "translate(0,0)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5E5D",
    transform: "translate(0,0)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#655F62",
    transform: "translate(0,0)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F5F5E",
    transform: "translate(0,0)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#606160",
    transform: "translate(0,0)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666564",
    transform: "translate(0,0)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666163",
    transform: "translate(0,0)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656464",
    transform: "translate(0,0)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656463",
    transform: "translate(0,0)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F6160",
    transform: "translate(0,0)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636163",
    transform: "translate(0,0)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656363",
    transform: "translate(0,0)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676466",
    transform: "translate(0,0)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#616161",
    transform: "translate(0,0)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626362",
    transform: "translate(0,0)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626060",
    transform: "translate(0,0)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656663",
    transform: "translate(0,0)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636361",
    transform: "translate(0,0)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61615F",
    transform: "translate(0,0)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61615D",
    transform: "translate(0,0)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636362",
    transform: "translate(0,0)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636262",
    transform: "translate(0,0)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676765",
    transform: "translate(0,0)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646565",
    transform: "translate(0,0)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646364",
    transform: "translate(0,0)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646661",
    transform: "translate(0,0)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626361",
    transform: "translate(0,0)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#60605E",
    transform: "translate(0,0)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646563",
    transform: "translate(0,0)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#616160",
    transform: "translate(0,0)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646464",
    transform: "translate(0,0)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646462",
    transform: "translate(0,0)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A19F",
    transform: "translate(0,0)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A8A9",
    transform: "translate(0,0)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4B4B4",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ffecbd6777ccd1d287820422376cae32.svg";
export { ForwardRef as ReactComponent };